import { useTranslation } from "next-i18next"
import React, { useState } from "react"
import styled from "styled-components"
import Button from "./_UI/ButtonNew"
import { theme } from "../Mixin"

function Collapsible({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation(["common"])
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <SectionContainer isExpanded={isExpanded}>
      <Content data-expanded={isExpanded}>{children}</Content>
      <ButtonWrapper>
        <Button
          className="button-header"
          arrowType={isExpanded ? "up" : "down"}
          styleType="text"
          content={
            isExpanded ? t("Collapsible.showLess") : t("Collapsible.showMore")
          }
          onClick={(e: any) => {
            e.preventDefault()
            setIsExpanded(!isExpanded)
          }}
        />
      </ButtonWrapper>
    </SectionContainer>
  )
}

export default Collapsible

const SectionContainer = styled.div<{ isExpanded: boolean }>`
  overflow: hidden;
  max-height: ${({ isExpanded }) => (isExpanded ? "100%" : "1000px")};
  position: relative;
  transition: max-height 0.3s;

  @media (${theme.lg}) {
    max-height: unset;
  }
`

const Content = styled.div`
  padding-bottom: 36px;
  &[data-expanded="false"]::after {
    content: "";
    display: block;
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100px;
    background: linear-gradient(180deg, rgba(3, 18, 46, 0) 0%, #03122e 100%);
    pointer-events: none;
  }
  @media (${theme.lg}) {
    padding-bottom: 12px;
  }
`

const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);

  @media (${theme.lg}) {
    visibility: hidden;
  }
`
